import { projects, strategicAssets } from "../../data/projects";

export const staticPortfolioRepository = {
  getProjects() {
    return projects;
  },
  getStrategicAssets() {
    return strategicAssets;
  },
};
